export default __webpack_public_path__ + "static/media/double-arrow.a0137a4d.svg";